export const TRPC_API_URL = "/api/proxy/v2";
